export default "__VITE_ASSET__DBiX$zLv__"